import { Input } from "antd";

const BaseInput = (props) => {
  return (

    <Input
      className="base-input"
      { ...props }
      placeholder={ props.placeholder }
    />

  )
}

export default BaseInput
